import { render, staticRenderFns } from "./PtuErrosFiltro.vue?vue&type=template&id=2f03b1b4"
import script from "./PtuErrosFiltro.vue?vue&type=script&lang=js"
export * from "./PtuErrosFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports